import React from 'react';

import { add, differenceInCalendarDays, parse } from 'date-fns';

export default (agendaItem) => {
  if (!agendaItem?.start_time) return '';

  // agenda items are always returned as UTC.
  // we have to use +00 since parse doesn't support time zone names
  const startTime = parse(`${agendaItem.start_time} +00`, 'HH:mm:ss x', new Date());

  const endTime = add(startTime, {
    hours: agendaItem.duration.hour || 0,
    minutes: agendaItem.duration.minute || 0,
  });

  const locale = document.documentElement.lang || 'en';
  const getTimeString = (date) => date.toLocaleString(locale, { timeStyle: 'short' });
  const daysSpanned = differenceInCalendarDays(endTime, startTime);

  const timeZoneName = new Intl.DateTimeFormat(locale, { timeZoneName: 'short' })
    .formatToParts(endTime)
    .find(({ type }) => type === 'timeZoneName').value;

  return (
    <>
      {getTimeString(startTime)} — {getTimeString(endTime)}
      {Boolean(daysSpanned) && <sup>+{daysSpanned}</sup>} {timeZoneName}
    </>
  );
};
